import { updateSelectorIdsInStorage } from '../utils/selectorOptions';
import {
  RECEIVE_SELECTOR_VALS,
  SET_ACTIVE_SELECTOR_VALS,
  FIELD_NOT_FOUND_FAILURE,
} from '../constants/actionTypes';

export function setActiveSelectorVals(
  fieldId,
  activeMapLayers,
  activeSeasons,
  seasons
) {
  // Only the single view data js stored.
  updateSelectorIdsInStorage(
    fieldId,
    activeMapLayers[0].id,
    activeSeasons[0].id
  );
  return {
    type: SET_ACTIVE_SELECTOR_VALS,
    activeMapLayers,
    activeSeasons,
    seasons,
  };
}

export function receiveSelectorVals(
  seasons,
  sortedSeasonKeys,
  layers,
  activeVals
) {
  return {
    type: RECEIVE_SELECTOR_VALS,
    seasons,
    sortedSeasonKeys,
    layers,
    activeVals,
  };
}

export function fieldNotFoundFailure() {
  return {
    type: FIELD_NOT_FOUND_FAILURE,
  };
}
